import '../style/Home.css';
import background from '../img/image_home_2.jpg';
import Contacto from './Contacto';
import Formulario from './Formulario';
import ProductosHome from './Productos/ProductosHome';
import ContenedorRecetas from './Recetas/ContenedorRecetas';

export default function Home() {
  return (
    <>
      <div id='home' className='home' style={{ backgroundImage: `url(${background})`, backgroundSize: 'cover', backgroundPosition: 'center' }}>
        <h1>¿Sabes lo que vas a tomar hoy?</h1>
        <div className='presentacion'>
          <p>Las mejores bebidas para disfrutar como más te gusta.</p>
          <p>Entrega rápida y sin costo.</p>
          <p>Te dejamos muchas recetas para que encuentres tu favorita.</p>
        </div>
      </div>

      <section id="productos">
        <ProductosHome />
      </section>

      <section>
        <ContenedorRecetas />
      </section>
      <section id="contacto">
        <Contacto />
      </section>
      <section>
        <Formulario />
      </section>


    </>
  )
}
